import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATE_TRACKERS_PERMISSIONS } from '@modules/affiliate-trackers/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IAffiliateProgramCreativeOptionsResponse,
} from '../types';
import {
  AFFILIATE_TRACKERS_CREATIVES_OPTIONS_QUERY_KEY,
  AFFILIATE_TRACKERS_CREATIVES_OPTIONS_URL,
} from '../constants';

export default function useAffiliateTrackersCreativeOptionsQuery(
): IContextQueryResult<IAffiliateProgramCreativeOptionsResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateProgramCreativeOptionsResponse>({
    queryKey: [AFFILIATE_TRACKERS_CREATIVES_OPTIONS_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAffiliateProgramCreativeOptionsResponse>(
      AFFILIATE_TRACKERS_CREATIVES_OPTIONS_URL,
      {
        signal,
        permission: AFFILIATE_TRACKERS_PERMISSIONS.SHOW_CREATIVE,
      },
    ),
  });
}
